import React from 'react';
import { Typography, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import { IUser } from 'interfaces/IUser';
import { Link } from 'react-router-dom';

interface ISubscribeModalProps {
  name: string,
  description: string,
  price: number,
  curUser: IUser,
  stripeTeam: any,
  activeSub: boolean,
  screening?: boolean,
}

const SubscribeModal: React.FC<ISubscribeModalProps> = ({ screening, name, description, curUser }) => {
  const history = useHistory();

  return (
    <div className={`subscribe-modal${screening ? '-screening' : ''}`}>
      <div className='sub-header'>
        <Typography variant='h6' className='text-white'
          style={{
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0.15px'
          }}
        >
          {name}
        </Typography>
        <svg style={{ cursor: 'pointer' }} onClick={() => history.push('/')} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M15.71 8.29008C15.6171 8.19635 15.5065 8.12196 15.3846 8.07119C15.2627 8.02042 15.132 7.99428 15 7.99428C14.868 7.99428 14.7373 8.02042 14.6154 8.07119C14.4936 8.12196 14.383 8.19635 14.29 8.29008L12 10.5901L9.71002 8.29008C9.52171 8.10178 9.26632 7.99599 9.00002 7.99599C8.73372 7.99599 8.47832 8.10178 8.29002 8.29008C8.10171 8.47838 7.99593 8.73378 7.99593 9.00008C7.99593 9.26638 8.10171 9.52178 8.29002 9.71008L10.59 12.0001L8.29002 14.2901C8.19629 14.383 8.1219 14.4936 8.07113 14.6155C8.02036 14.7374 7.99422 14.8681 7.99422 15.0001C7.99422 15.1321 8.02036 15.2628 8.07113 15.3847C8.1219 15.5065 8.19629 15.6171 8.29002 15.7101C8.38298 15.8038 8.49358 15.8782 8.61544 15.929C8.7373 15.9797 8.86801 16.0059 9.00002 16.0059C9.13203 16.0059 9.26274 15.9797 9.38459 15.929C9.50645 15.8782 9.61705 15.8038 9.71002 15.7101L12 13.4101L14.29 15.7101C14.383 15.8038 14.4936 15.8782 14.6154 15.929C14.7373 15.9797 14.868 16.0059 15 16.0059C15.132 16.0059 15.2627 15.9797 15.3846 15.929C15.5065 15.8782 15.6171 15.8038 15.71 15.7101C15.8037 15.6171 15.8781 15.5065 15.9289 15.3847C15.9797 15.2628 16.0058 15.1321 16.0058 15.0001C16.0058 14.8681 15.9797 14.7374 15.9289 14.6155C15.8781 14.4936 15.8037 14.383 15.71 14.2901L13.41 12.0001L15.71 9.71008C15.8037 9.61712 15.8781 9.50652 15.9289 9.38466C15.9797 9.2628 16.0058 9.13209 16.0058 9.00008C16.0058 8.86807 15.9797 8.73736 15.9289 8.6155C15.8781 8.49364 15.8037 8.38304 15.71 8.29008ZM19.07 4.93008C18.1476 3.97498 17.0441 3.21316 15.8241 2.68907C14.604 2.16498 13.2918 1.88911 11.964 1.87757C10.6362 1.86604 9.31944 2.11905 8.09048 2.62186C6.86151 3.12467 5.745 3.8672 4.80607 4.80613C3.86714 5.74506 3.12461 6.86158 2.6218 8.09054C2.11899 9.3195 1.86598 10.6363 1.87751 11.9641C1.88905 13.2919 2.16491 14.6041 2.689 15.8241C3.21309 17.0442 3.97492 18.1476 4.93002 19.0701C5.85249 20.0252 6.95593 20.787 8.17597 21.3111C9.39601 21.8352 10.7082 22.111 12.036 22.1226C13.3638 22.1341 14.6806 21.8811 15.9096 21.3783C17.1385 20.8755 18.255 20.133 19.194 19.194C20.1329 18.2551 20.8754 17.1386 21.3782 15.9096C21.881 14.6807 22.1341 13.3639 22.1225 12.0361C22.111 10.7083 21.8351 9.39607 21.311 8.17603C20.7869 6.95599 20.0251 5.85255 19.07 4.93008ZM17.66 17.6601C16.3521 18.9695 14.6306 19.7849 12.7888 19.9674C10.9471 20.1499 9.09902 19.6881 7.55954 18.6609C6.02006 17.6336 4.88438 16.1043 4.34599 14.3336C3.80761 12.5628 3.89982 10.6602 4.60693 8.94986C5.31404 7.23951 6.59229 5.82723 8.22391 4.95364C9.85553 4.08006 11.7396 3.79921 13.555 4.15895C15.3705 4.5187 17.0051 5.49677 18.1803 6.92654C19.3555 8.35631 19.9986 10.1493 20 12.0001C20.0036 13.0514 19.7986 14.0929 19.3969 15.0645C18.9953 16.036 18.4049 16.9182 17.66 17.6601Z' fill='#F5FAFF'/>
        </svg>
      </div>
      <div className='sub-lottie'>
        <Player
          autoplay
          loop
          src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
        >
        </Player>
      </div>
      <div className='sub-details'>
        <Typography
          variant='h6'
          className='text-white'
          style={{
            fontSize: '20px',
            fontWeight: 600,
            letterSpacing: '0.15px',
            lineHeight: '24px',
          }}
        >
          Upgrade your plan to access the {name} feature
        </Typography>
        <Typography
          variant='h6'
          style={{
            fontSize: '17px',
            color: '#BDBEC1',
            lineHeight: '21px',
            fontWeight: 500
          }}
        >
          {description}
        </Typography>
        <Typography
          variant='h6'
          style={{
            fontSize: '18px',
            color: '#BDBEC1',
            lineHeight: '21px',
            fontWeight: 500,
            marginTop: '10px'
          }}
        >
          Please Navigate to Account &gt; Plans Tab &gt; Choose your Plan &gt; Checkout
        </Typography>
      </div>
      <div className='sub-help'>
        Have questions about this feature? Contact us at info@bite.com or learn more{' '}
        <a href='https://www.bitedata.io/pricing' rel='noreferrer' target={'_blank'} style={{ color: '#0E8BFF' }}>
          here
        </a>
      </div>
      <div className='sub-btns'>
        {curUser.selected_team?.attributes?.team_admin?.includes(curUser.basics?.email) ? (
          <>
            <div>
              <Button
                className='cancel-sub-btn'
                style={{
                  color: '#FFF',
                  padding: '10px 22px'
                }}
                onClick={() => history.push('/')}
              >
                Cancel
              </Button>
              <Link to={{
                pathname: '/profile',
                state: {
                  linkTab: 'Plans'
                }
              }}
              >
                <Button
                  className='subscribe-btn'
                  style={{
                    color: '#FFF',
                    padding: '10px 22px',
                  }}
                >
                  Go to Plans
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <div
            style={{
              margin: '0 auto'
            }}
          >
            <Typography
              variant='h6'
              className='text-white'
              style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#F5FAFF'
              }}
            >
              You need a {name} license to use this module. Contact your team admin for gaining access.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscribeModal;
